import React from "react";
import CoachService from "../../Services/Coach.service";
// Term for advisor is likely not to change, so we cache it here.
let termForCoach = null;
const useTermForCoach = () => {
    // Need to re-render when after we load in the term, so this needs to be stateful.
    const [statefulTerm, setStatefulTerm] = React.useState(termForCoach);
    React.useEffect(() => {
        if (!termForCoach) {
            CoachService.getTermForCoach().then((term) => {
                termForCoach = term;
                setStatefulTerm(term);
            });
        }
    }, []);
    return statefulTerm;
};
export default useTermForCoach;
